import NewService from "./NewService";
import { connect } from "react-redux";
import { addService, setServiceActiveTab } from "../../../redux/actions/newService/service.actions";
import { SubmitRequst } from "../../../redux/actions/newService/submitServiceRequest.actions";
import { getLocations } from "../../../redux/actions/newService/locations.action";
import { getCustomers } from "../../../redux/actions/newService/customers.action";
import { closeNewServiceForm, setIsAmendMode } from "../../../redux/actions/newService/service.actions";
import { getServicesList } from "../../../redux/actions/newService/servicesList.actions";
import { getServices } from "../../../redux/actions/newService/customerService.action";
import { getLiveServicesForAmendDropDown } from "../../../redux/actions/liveServies/liveServices.action";
import { openAlertPopup } from "../../../redux/actions/Alert/alert.action";
import {getContriesList} from "../../../redux/actions/newService/serviceCountries.action";
import {getRoamingPartnerList} from "../../../redux/actions/newService/roamingPartnerList.action";
import { SubmitUpdateRequst } from "../../../redux/actions/newService/updateServiceRequest.action";
import { getServiceDetail } from "../../../redux/actions/newService/serviceDetail.actions";
import { showErrorPopup } from "../../../redux/actions/customErrorPopup/customerrorpopup.action";

const mapStateToProps = (state) => {
    return {
      roamingPartnerName:state.newService.roamingPartnersList.data.data,
      countries:state.newService.serviceCountriesList.data,
      locations:state.newService.locations.locations.locations,
      organizations:state.newService.customers.customers.customers,
      myRights:state.myRights.myRights,
      services:state.newService.services.services.services,
      isServiceFromOpen:state.newService.service.isServiceFromOpen,
      isAmendMode:state.newService.service.isAmendMode,
      pops:state.liveServices.locationsOnNewDemandForm,
      liveServicesData:state.liveServices.liveServicedataOnNewDemandForm,
      initialValue:state.newService.service.initialValue,
      serviceActiveTab:state.newService.service.serviceActiveTab,
    }
  }
  
  const mapDispatchToProps = (dispatch) => {
    return {
      getLocations: () => {
        return dispatch(getLocations())
      },
      getCustomers: (payload) => {
        return dispatch(getCustomers())
      },
      submitRequest: (payload) => {
        return dispatch(SubmitRequst(payload))
      }, 
      closeNewServiceForm: () => {
        return dispatch(closeNewServiceForm())
      },
      getServicesList: (status = '', searchKey = '',next=null)=>{
        return dispatch(getServicesList(status, searchKey,next))
    },
      getServices: ()=>{
        return dispatch(getServices())
      },
      getLiveServices: (cp_name,searchKey, filter,customer="",serviceType="",status="") => {
        return dispatch(getLiveServicesForAmendDropDown(cp_name,searchKey, filter,customer,serviceType,status))
    },
      setIsAmendMode: (mode) => {
        return dispatch(setIsAmendMode(mode))
      },
      openAlertPopup: (payload) => {
        return dispatch(openAlertPopup(payload))
      },
      getContriesList: () => {
        return dispatch(getContriesList())
      },
      getRoamingPartnerList: () => {
        return dispatch(getRoamingPartnerList())
      },
      SubmitUpdateRequst: (payload,id) => {
        return dispatch(SubmitUpdateRequst(payload,id))
      },
      setServiceActiveTab: (tab) => {
        return dispatch(setServiceActiveTab(tab))
      },
       getServiceDetail: (requestId)=>{
        return dispatch(getServiceDetail(requestId))
      },
      showErrorPopup: (errorHeader,errormessage,isnote) => {
        return dispatch(showErrorPopup(errorHeader,errormessage,isnote))
      },
    }
  };
  
  export default connect(mapStateToProps, mapDispatchToProps)(NewService);


